import {NuxtIcon} from "#components";
import {h} from "vue";
import { createTextVNode as _createTextVNode, resolveDynamicComponent as _resolveDynamicComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  id: "svg-V7-logo_svg__Layer_1",
  "data-name": "Layer 1",
  viewBox: "0 0 200 59.9"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [
    _createElementVNode("defs", null, [
      (_openBlock(), _createBlock(_resolveDynamicComponent("style"), null, {
        default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
          _createTextVNode(".svg-V7-logo_svg__cls-2{fill:#452325}", -1)
        ]))]),
        _: 1
      }))
    ]),
    _cache[1] || (_cache[1] = _createElementVNode("path", {
      d: "M11.3 50.8h-.1l-5.4-22H0l7.9 30.7h6.7l7.8-30.7h-5.7l-5.4 22zM34.9 28.3c-5.7 0-9.7 2.7-9.7 10.3v11c0 7.6 4 10.3 9.7 10.3s9.7-2.7 9.7-10.3v-11c0-7.5-4-10.3-9.7-10.3Zm3.8 22.1c0 3.4-1.5 4.3-3.8 4.3s-3.8-.9-3.8-4.3V37.9c0-3.4 1.5-4.3 3.8-4.3s3.8.9 3.8 4.3v12.5ZM55.3 28.8h-5.9v30.7h15.3v-5.2h-9.4V28.8zM77.5 28.3c-5.7 0-9.7 2.7-9.7 10.3v11c0 7.6 4 10.3 9.7 10.3s9.7-2.7 9.7-10.3v-11c0-7.5-4-10.3-9.7-10.3Zm3.9 22.1c0 3.4-1.5 4.3-3.8 4.3s-3.8-.9-3.8-4.3V37.9c0-3.4 1.5-4.3 3.8-4.3s3.8.9 3.8 4.3v12.5ZM90.2 34h6.9v25.5h5.9V34h6.8v-5.2H90.2V34zM119.2 46.2h7.8V41h-7.8v-7h10.2v-5.2h-16.1v30.7h16.6v-5.2h-10.7v-8.1zM147.2 28.8h-6.7l-7.9 30.7h5.8l5.4-22 5.5 22h5.8l-7.9-30.7z",
      class: "svg-V7-logo_svg__cls-2"
    }, null, -1)),
    _cache[2] || (_cache[2] = _createElementVNode("path", {
      d: "m200 21.6-7.2-7.2-1.6-1.6V16l-1.6 1.6v-6.4L188 9.6v9.6l-1.6 1.6V8l-.8-.8-7.2-7.2-7.2 7.2-.8.8v12.8l-1.6-1.6V9.6l-1.6 1.6v6.4l-1.6-1.6v-3.2l-1.6 1.6-7.2 7.2 7.2 7.2 1.6 1.6v-3.2l1.6-1.6V32l1.6 1.6V24l1.6-1.6v12.8l.8.8 7.2 7.2 7.2-7.2.8-.8V22.3l1.6 1.6v9.6l1.6-1.6v-6.4l1.6 1.6v3.2l1.6-1.6 7.2-7.1Zm-21.6-7.2Zm6.4 7.9v12.8l-1.6-1.6v-9.6l-1.6 1.6v6.4l-1.6-1.6v-3.2l-1.6 1.6-1.6-1.6v3.2l-1.6 1.6v-6.4l-1.6-1.6v9.6l-1.6 1.6V22.3l-.8-.8.8-.8V8l1.6 1.6v9.6l1.6-1.6v-6.4l1.6 1.6V16l1.6-1.6L180 16v-3.2l1.6-1.6v6.4l1.6 1.6V9.6l1.6-1.6v12.8l.8.8-.8.7Z",
      style: {"fill":"#e10e49"}
    }, null, -1))
  ]))
}
export default { render() { return h(NuxtIcon, {icon: {render}, name: "V7-logo"}) } }